import { call, put, select, takeLatest } from "redux-saga/effects";
import {
    fetchDynamicTabsFailure,
    fetchDynamicTabsSuccess,
    FETCH_DYNAMIC_TABS_REQUEST
} from "../actions/dynamicTabActions";
import { fetchDynamicTabsData } from "../../../services/commonService";

// Worker Saga
function* fetchDynamicTabsSaga(action) {
    try {
        const result = yield call(
            fetchDynamicTabsData,
            action.payload.clientName,
            action.payload.accountName
        );
        yield put(fetchDynamicTabsSuccess(result));
    } catch (error) {
        yield put(fetchDynamicTabsFailure(error.message));
    }
}

// Watcher Saga
export function* watchFetchDynamicTabs() {
  yield takeLatest(FETCH_DYNAMIC_TABS_REQUEST, fetchDynamicTabsSaga);
}
